import { createRouter, createWebHistory, type Router } from "vue-router";
import { nextTick } from "vue";

import { usePageStore } from "~/stores";
import { printOrCaptureException } from "~/utils/exceptionClient";
import { recordDuration } from "~/utils/observability";

import { checkNavigationRules, runAfterNavigationRules } from "./common";
import ROUTES from "./routes";

const router: Router = createRouter({
  history: createWebHistory(""),
  routes: ROUTES,
});

const navigationStarts = new WeakMap<object, number>();

router.beforeEach((to, from) => {
  if (!usePageStore().userDataLoaded) {
    return true;
  }
  navigationStarts.set(to, performance.now());
  return checkNavigationRules(to, from);
});

router.afterEach(async (to, from, failure) => {
  if (!usePageStore().userDataLoaded) {
    return;
  }
  runAfterNavigationRules(to, from);
  const startedAt = navigationStarts.get(to);
  if (failure || startedAt === undefined) {
    return;
  }
  await nextTick();
  recordDuration("route.content_ready", startedAt, {
    navigation_kind: "navigation",
    route: String(to.name ?? "unknown"),
  });
});

router.onError((error: Error) => {
  if (error.message.includes("Failed to fetch dynamically imported module")) {
    printOrCaptureException(error);
    // eslint-disable-next-line no-alert
    if (window.confirm("Dart didn't load correctly. Please reload the page.")) {
      window.location.reload();
    }
  }
});

export default router;
